module.exports = __webpack_public_path__ + "static/media/do.107c3850.svg";